<script setup>
import { useI18n } from 'vue-i18n'

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  width: {
    type: String,
    default: '640px',
  },
})

defineEmits(['close'])

const { t } = useI18n()

const TERMS_SECTION_COUNT = 18

function getSectionContent(sectionIndex) {
  const key = `newBradley.termsOfServiceModal.section${sectionIndex}Content`
  const content = t(key)
  if (!content || content === key)
    return []
  return content.split(/\n{2,}/).filter(Boolean)
}
</script>

<template>
  <teleport to="body">
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0"
      enter-to-class="transform opacity-100"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="transform opacity-100"
      leave-to-class="transform opacity-0"
    >
      <div
        v-if="open"
        class="fixed flex justify-end bg-white/70"
        style="z-index: 150; top: 0; left: 0; right: 0; bottom: 0;"
        @click.self="$emit('close')"
      >
        <div
          class="bg-white h-full flex flex-col shadow-2xl border-l border-dss-surface-200"
          :style="{
            width: props.width,
            maxWidth: '100%',
          }"
        >
          <!-- Header -->
          <div class="flex items-center justify-between px-6 py-4 border-b border-dss-surface-200">
            <h2 class="font-hellix text-xl font-[450] leading-none">
              {{ t('newBradley.termsOfServiceModal.title') }}
            </h2>
            <button
              class="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              @click="$emit('close')"
            >
              <i class="pi pi-times text-gray-600 text-lg" />
            </button>
          </div>

          <!-- Content (i18n: PT / EN only) -->
          <div class="flex-1 overflow-y-auto px-6 py-6 space-y-6 text-dss-primary-950">
            <p class="font-inter text-sm font-normal leading-5 tracking-[0.005em] mb-4">
              {{ t('newBradley.termsOfServiceModal.intro') }}
            </p>

            <div
              v-for="n in TERMS_SECTION_COUNT"
              :key="n"
              class="space-y-3"
            >
              <h2 class="font-inter text-base font-semibold leading-6 tracking-[0.005em] mb-3">
                {{ t(`newBradley.termsOfServiceModal.section${n}Title`) }}
              </h2>
              <p
                v-for="(paragraph, idx) in getSectionContent(n)"
                :key="idx"
                class="font-inter text-sm font-normal leading-5 tracking-[0.005em] mb-2"
              >
                {{ paragraph }}
              </p>
            </div>
          </div>

          <!-- Footer -->
          <div class="px-6 py-4 border-t border-dss-surface-200">
            <button
              class="w-full py-3 bg-dss-primary-500 hover:bg-dss-primary-600 text-white font-hellix font-medium rounded-lg transition-colors"
              @click="$emit('close')"
            >
              {{ t('newBradley.termsOfServiceModal.next') }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>
